import {
  getEmailRecommendedInteractiveProductsSchema,
  interactiveCartProductSchema,
} from "@redotech/redo-marketing-templates-common/email-product-recommendation";
import * as z from "zod";

export const getEmailInteractiveProductRecommendations = {
  name: "getEmailInteractiveProductRecommendations" as const,
  input: getEmailRecommendedInteractiveProductsSchema,
  output: z.array(interactiveCartProductSchema),
};
